import * as React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import '../index.css'
import { makeStyles } from "@material-ui/core/styles";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import '../../images/logo_cut.jpg';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import { FaMobileAlt, FaPhone, FaRegEnvelope } from "react-icons/fa";



const useStyles = makeStyles((theme) => ({
    wrapper: {
        flexGrow: 1
    },
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-around",
        overflow: "hidden",
        backgroundColor: theme.palette.background.paper,
    },
    gridList: {
        width: "70%",
        height: "100%",
    },
    titleBar: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
    image: {
        opacity: 1,
        display: "block",
        width: "100%",
        height: "auto",
        transition: ".5s ease",
        backfaceVisibility: "hidden"
    },
    middle: {
        transition: ".5s ease",
        opacity: 0,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        height: "100%",
        widht: "100%"
    },
    text: {
        backgroundColor: "#4CAF50",
        color: "white",
        fontSize: "16px",
        padding: "16px 32px"
    }

}));

export default function GridComponent({employeeList}) {
    const classes = useStyles();

    const [title, setTitle] = React.useState("");


    function handleIconClick(index, icon) {
        console.log("icon", icon);
        setTitle(icon);

    }

    return (
        <div>
            <div className="header_Team">
                <div className="header_openHours_text">Team</div>
                <div className="header_openHours_body">Unser Team hilft Ihnen bei Ihren Anliegen</div>
            </div>
            <div className="root">
                <GridList cellHeight={600}  spacing={0} cols={1} className="gridList">
                    <GridListTile key={"1"}>
                        <div className="container container_no_padding">
                            <div className="cardContainer">
                                <div className="department">
                                    <div className="logoDiv">
                                        <img
                                            src="./images/logo_cut.jpg"
                                            className="cardImage"
                                            alt="Mehele Landtechnik"
                                        />
                                    </div>
                                    Verkauf/Geschäftsleitung
                                </div>
                                <div>
                                    <ul className="contactCard">
                                        <li><AccountBoxIcon />Rainer Mehele </li>
                                        <li><PhoneIcon /><a className="link-unstyled-team" href="tel:00435576723970">+43-5576-72397-0</a></li>
                                        <li><PhoneIphoneIcon /><a className="link-unstyled-team" href="tel:00436643388567">+43-664-33-88-567</a></li>
                                        <li><EmailIcon /><a className="link-unstyled-team" href="mailto:rainer.mehele@mehele.at">rainer.mehele@mehele.at</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </GridListTile>
                    <GridListTile key={"2"}>
                        <div className="container container_no_padding">
                            <div className="cardContainer">
                                <div className="department">
                                    <div className="logoDiv">
                                        <img
                                            src="./images/logo_cut.jpg"
                                            className="cardImage"
                                            alt="Mehele Landtechnik"
                                        />
                                    </div>
                                    Rechnungswesen
                                </div>
                                <div>
                                    <ul className="contactCard">
                                        <li><AccountBoxIcon />Barbara Psaier </li>
                                        <li><PhoneIcon /><a className="link-unstyled-team" href="tel:00435576723970">+43-5576-72397-0</a></li>
                                        <li><EmailIcon /><a className="link-unstyled-team" href="mailto:office@mehele.at">office@mehele.at</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </GridListTile>

                    <GridListTile key={"3"}>
                        <div className="container container_no_padding">
                            <div className="cardContainer">
                                <div className="department">
                                    <div className="logoDiv">
                                        <img
                                            src="./images/logo_cut.jpg"
                                            className="cardImage"
                                            alt="Mehele Landtechnik"
                                        />
                                    </div>
                                    Ersatzteillager/Zubehör
                                </div>
                                <div>
                                    <ul className="contactCard">
                                        <li><AccountBoxIcon />Markus Rebhandl</li>
                                        <li><AccountBoxIcon />Raphael Volger</li>
                                        <li><AccountBoxIcon />Wolfgang Rüdisser</li>
                                        <li><PhoneIcon /><a className="link-unstyled-team" href="tel:004355767239773">+43-5576-72397-73</a></li>
                                        <li><EmailIcon /><a className="link-unstyled-team" href="mailto:logistik@mehele.at">logistik@mehele.at</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </GridListTile>

                    <GridListTile key={"4"}>
                        <div className="container container_no_padding">
                            <div className="cardContainer">
                                <div className="department">
                                    <div className="logoDiv">
                                        <img
                                            src="./images/logo_cut.jpg"
                                            className="cardImage"
                                            alt="Mehele Landtechnik"
                                        />
                                    </div>
                                    Werkstatt/Service/Pickerl
                                </div>
                                <div>
                                    <ul className="contactCard">
                                        <ul className="employeeList">
                                            <li><AccountBoxIcon />Stefan Mehele </li>
                                            <li><AccountBoxIcon />Summer Dietmar </li>
                                            <li><AccountBoxIcon />Maissen Jakob </li>
                                            <li><AccountBoxIcon />Moosbrugger Erich </li>
                                            <li><AccountBoxIcon />Fenkart Jürgen </li>
                                        </ul>
                                        <ul>
                                            <li><AccountBoxIcon />Resch Lorenz </li>
                                            <li><AccountBoxIcon />Burtscher Christoph </li>
                                            <li><AccountBoxIcon />Erhard Jan </li>
                                            <li><AccountBoxIcon />Mayer Christian </li>
                                            <li><AccountBoxIcon />Burtscher Christoph</li>
                                        </ul>
                                        <li><PhoneIcon /><a className="link-unstyled-team" href="tel:004355767239774">+43-5576-72397-74</a></li>
                                        <li><EmailIcon /><a className="link-unstyled-team" href="mailto:werkstatt@mehele.at">werkstatt@mehele.at</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </GridListTile>

                    <GridListTile key={"5"}>
                        <div className="container container_no_padding">
                            <div className="cardContainer">
                                <div className="department">
                                    <div className="logoDiv">
                                        <img
                                            src="./images/logo_cut.jpg"
                                            className="cardImage"
                                            alt="Mehele Landtechnik"
                                        />
                                    </div>
                                    Service am Hof
                                </div>
                                <div>
                                    <ul className="contactCard">
                                        <li><AccountBoxIcon />Burtscher Christoph</li>
                                        <li><AccountBoxIcon />Fenkart Jürgen </li>
                                        <li><PhoneIphoneIcon /><a className="link-unstyled-team" href="tel:00436505106494">+43-650-5106494</a></li>
                                        <li><EmailIcon /><a className="link-unstyled-team" href="mailto:werkstatt@mehele.at">werkstatt@mehele.at</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </GridListTile>
                </GridList>
            </div>
        </div>
    );
}
